// Overlay de carregamento que cobre:
//   1) Suspense do chunk Phaser (lazy import do PhaserHost ~30KB).
//   2) O preload da cena específica de combate (background ~1MB +
//      música ~3-5MB + sprites de inimigo). Sem este overlay, ficava
//      tela preta visível depois do Suspense fechar.
//
// Identidade visual: fundo escuro casado com bg do Phaser, anel
// dourado giratório e contagem regressiva de 5s. Se o cenário
// terminar antes, GamePage desmonta o overlay imediatamente; se
// passar dos 5s, a contagem fica em "..." sem assustar o jogador.

import { useEffect, useState } from 'react'

interface LoadingArenaProps {
  /** Segundos iniciais da contagem regressiva. Default 5. */
  initialCountdown?: number
}

export default function LoadingArena({ initialCountdown = 5 }: LoadingArenaProps) {
  const [secs, setSecs] = useState(initialCountdown)

  useEffect(() => {
    const id = window.setInterval(() => {
      setSecs((s) => Math.max(0, s - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: '#1B1A17',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1.25rem',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          border: '3px solid rgba(229, 176, 85, 0.25)',
          borderTopColor: '#E5B055',
          borderRadius: '50%',
          animation: 'capoeira-spin 0.9s linear infinite',
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: '"Silkscreen", monospace',
            fontSize: '1.5rem',
            color: '#E5B055',
            textShadow: '0 0 8px rgba(229,176,85,0.6)',
          }}
        >
          {secs > 0 ? secs : '...'}
        </div>
      </div>
      <p
        style={{
          fontFamily: '"Silkscreen", monospace',
          fontSize: '1rem',
          color: '#E5B055',
          letterSpacing: '0.12em',
          margin: 0,
          opacity: 0.85,
          textTransform: 'uppercase',
        }}
      >
        Entrando na Roda
      </p>
      <style>{`
        @keyframes capoeira-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}
